export default __webpack_public_path__ + "static/media/line.b324587f.svg";